//配置文件：axiosapi.js
import {devUrl} from "@/common/common";
import axios from "axios";
const axiosapi = axios.create({
    baseURL: 'https://www.huaun.com', //基础的地址
    timeout: 5000  //连接超时的时间(单位是毫秒)
})
export default  axiosapi  //axiosapi是axios的实例